export const NATIVE_TOKEN_MOCK_ADDRESS='$$native##';